import './Discussions.scss';
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import AuthContext from "../../context/AuthContext";
import SnackbarContext from "../../context/SnackbarContext";
import { API_BASE_URL } from '../../config';


function formatDate(iso) {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('ar', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
        return iso;
    }
}


export default function Discussions() {
    const { authTokens } = useContext(AuthContext);
    const { setSnackbar } = useContext(SnackbarContext);
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`${API_BASE_URL}/api/discussions/topics/`);
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                const data = await r.json();
                if (!cancelled) setTopics(Array.isArray(data) ? data : []);
            } catch {
                if (!cancelled) setSnackbar({ content: 'تعذر تحميل النقاشات', success: false });
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [setSnackbar]);

    return (
        <>
        <Navbar />
        <main className='disc-page'>
            <div className='disc-container'>
                <header className='disc-header'>
                    <div>
                        <h1>النقاشات</h1>
                        <p>شارك أفكارك مع القرّاء والكتّاب. ابدأ موضوعًا جديدًا أو علّق على موضوع نشِط.</p>
                    </div>
                    {authTokens ? (
                        <Link to='/discussions/new' className='disc-new'>+ موضوع جديد</Link>
                    ) : (
                        <Link to='/register' className='disc-new'>سجّل لبدء موضوع</Link>
                    )}
                </header>

                {loading ? (
                    <p className='disc-empty'>جارٍ التحميل…</p>
                ) : topics.length === 0 ? (
                    <p className='disc-empty'>لا توجد مواضيع بعد. كن أوّل من يبدأ نقاشًا.</p>
                ) : (
                    <ul className='disc-list'>
                        {topics.map(t => (
                            <li key={t.id}>
                                <Link to={`/discussions/${t.id}`} className='disc-card'>
                                    <div className='disc-card-main'>
                                        <h3 className='disc-card-title'>{t.title}</h3>
                                        <p className='disc-card-meta'>
                                            بقلم <strong>{t.author_username}</strong> · {formatDate(t.created_at)}
                                        </p>
                                    </div>
                                    <div className='disc-card-stats'>
                                        <span>{t.comment_count} {t.comment_count === 1 ? 'تعليق' : 'تعليقات'}</span>
                                        <span className='disc-card-activity'>آخر نشاط: {formatDate(t.last_activity_at)}</span>
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </main>
        <Footer />
        </>
    );
}
